export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "payment_settlement_and_deductible": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Procéder au paiement du solde tout compte et de la franchise"])},
        "payment_settlement": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Procéder au paiement du solde tout compte"])},
        "payment_deductible": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Procéder au paiement de la franchise"])},
        "complete_declaration": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Compléter la déclaration"])},
        "add_quotation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ajouter un devis"])},
        "add_invoice": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ajouter une facture"])}
      },
      "en": {
        "payment_settlement_and_deductible": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Proceed with the payment of the final settlement and deductible"])},
        "payment_settlement": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Proceed with the payment of the final settlement"])},
        "payment_deductible": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Proceed with the deductible payment"])},
        "complete_declaration": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Complete the declaration"])},
        "add_quotation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add a quotation"])},
        "add_invoice": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add an invoice"])}
      }
    }
  })
}
